import React from 'react';
import logo from './img/logo.png'
import { Link } from 'react-router-dom'

import WorldMap from './img/world-map.png'

const About = ({showContact}) => (
  <section className="about-area gray-bg section-padding  wow fadeIn" id="home-link" style={{ minHeight: '100vh' }}>
        <div className="container">
            <div className="row">
              <div className="col-xs-12">
              <div id="about-container">
                  <img src={WorldMap} alt="logo" />
                  <p style={{paddingTop: 50, textAlign: 'center'}}>
                    Es un grupo de Despachantes de Aduana, Agentes de Transporte y Profesionales en Comercio Exterior con un solo objetivo, brindarle un servicio de alta calidad, totalmente personalizado y con presencia operativa en todas las áreas involucradas.
                  </p>
                  { showContact && <div className="promo-bottom-content" style={{ paddingTop: 35 }}>
                    <Link to="/contacto" className="tcc-contact-button">Contáctenos</Link>
                  </div> }
                </div>
              </div>
                
            </div>
        </div>
    </section>
)

export default About